module.exports = __webpack_public_path__ + "media/images/services/terms2-bb3d61ea0223ed6dd0d5941d6532b816.png";